import useScrollReveal from '../../../hooks/useScrollReveal';
import { products } from '../../../mocks/products';

export default function PowerTubeSpecs() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: contentRef, isVisible: contentVisible } = useScrollReveal({ threshold: 0.1 });

  const product = products.find((p) => p.id === 'urban-rebel');
  const specs = product?.specs ?? {};

  const specLabels: Record<string, string> = {
    product: 'Product',
    type: 'Type',
    function: 'Function',
    wheels: 'Wheels',
    battery: 'Battery',
    range: 'Range',
    topSpeed: 'Top Speed',
    chargeTime: 'Charge Time',
    powerTubeWeight: 'PowerTube Weight',
    batteryWeight: 'Battery Weight',
    systemWeight: 'System Weight with Battery',
    compatibility: 'Compatibility',
    installTime: 'Install Time',
    removal: 'Removal',
    joystick: 'Joystick',
    airTravel: 'Air Travel',
    warranty: 'Warranty',
  };

  return (
    <section id="specs" className="py-16 md:py-24 px-4 md:px-6 bg-black">
      <div className="max-w-5xl mx-auto">
        <div
          ref={headerRef}
          className={`transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-400 text-sm font-bold tracking-widest text-center mb-3 uppercase">By the Numbers</p>
          <h2 className="text-3xl md:text-6xl font-black tracking-tight text-center mb-4">
            SPECIFICATIONS
          </h2>
          <p className="text-gray-400 text-center max-w-2xl mx-auto mb-8 md:mb-12 text-sm md:text-base">
            Every detail engineered for real-world independence. Here&apos;s what&apos;s under the hood of the IND Mobility PowerTube.
          </p>
        </div>

        <div ref={contentRef}>
          <div className="bg-zinc-900 rounded-2xl overflow-hidden border border-zinc-800">
            {Object.entries(specs).map(([key, value], index) => (
              <div
                key={key}
                className={`flex flex-col sm:flex-row sm:items-center sm:justify-between px-4 md:px-8 py-3 md:py-5 gap-0.5 sm:gap-4 transition-all duration-500 ease-out ${
                  index % 2 === 0 ? 'bg-zinc-900' : 'bg-zinc-800/40'
                } ${index < Object.entries(specs).length - 1 ? 'border-b border-zinc-800' : ''} ${
                  contentVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'
                }`}
                style={{ transitionDelay: contentVisible ? `${index * 50}ms` : '0ms' }}
              >
                <span className="text-xs sm:text-sm text-gray-400 font-medium uppercase tracking-wide sm:normal-case sm:tracking-normal">{specLabels[key] || key}</span>
                <span className="text-sm font-semibold text-white sm:text-right sm:max-w-xs">{value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
